// extracted by mini-css-extract-plugin
export var acitonButtons = "_gu-0";
export var additionalIcon = "_gu-f";
export var block = "_gu-1";
export var blockContent = "_gu-7";
export var blockDescription = "_gu-8";
export var blockIcon = "_gu-9";
export var blockTitle = "_gu-6";
export var border = "_gu-a";
export var center = "_gu-l";
export var edge = "_gu-b";
export var edgeLabel = "_gu-c";
export var edgePath = "_gu-d";
export var error = "_gu-e";
export var flowchart = "_gu-g";
export var flowchartContent = "_gu-h";
export var highlighted = "_gu-3";
export var hover = "_gu-4";
export var icon = "_gu-i";
export var left = "_gu-m";
export var navButton = "_gu-j";
export var navButtons = "_gu-k";
export var right = "_gu-n";
export var selected = "_gu-2";
export var small = "_gu-5";